import React from 'react';

import Header from '../../components/user/header/Header.jsx';
import SubIntro from '../../components/user/sub_intro1/Intro.jsx';
import Content from '../../components/user/sub6_1/Content.jsx';
import Footer from '../../components/user/footer/Footer.jsx';

import '../../styles/user/common.css';
import '../../styles/user/default.css';
import '../../styles/user/fixed.css';
import '../../styles/user/font.css';
import '../../styles/user/footer.css';
import '../../styles/user/header.css';
import '../../styles/user/main.css';
import '../../styles/user/slick-theme.css';
import '../../styles/user/slick.css';
import '../../styles/user/sub.css';

export default function Sub6_1() {
  const introData = {
    mainTitle: ' 고객센터',
    subTitle: '아래 빈칸을 입력하시면 상담을 도와드리겠습니다',
    menuItems: [
      { title: '제품문의', link: '/sub6_1', active: true },
      { title: '자가관리방법', link: '/sub6_2', active: false },
    ],
  };

  return (
    <>
      <Header />
      <div className="short-height">
        <SubIntro
          mainTitle={introData.mainTitle}
          subTitle={introData.subTitle}
          menuItems={introData.menuItems}
        />
      </div>
      <Content />
      <Footer />
    </>
  );
}
